import { ThemeProvider } from 'emotion-theming'
import withProvider from '../withProvider'
import theme from './themes'

const withEmotionProvider = withProvider(ThemeProvider, { theme })

export default withEmotionProvider
